module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-113.3b7b8323.svg";